import type { ColDef } from "~/components/grid/AgGrid";
import type { InspectionRow } from "~/helpers/aiChat/migrationReview";

import migrationReview from "~/helpers/aiChat/migrationReview";

const inspectionColumns = (fieldNames: readonly string[], sourceRowsHeader: string): ColDef<InspectionRow>[] => [
	{ colId: "sourceRows", field: "sourceRows", headerName: sourceRowsHeader, pinned: "left", width: 110 },
	...fieldNames.map(
		(name): ColDef<InspectionRow> => ({
			colId: `field:${name}`,
			headerName: migrationReview.inertCellText(name),
			valueGetter: ({ data }) => migrationReview.inertCellText(data?.values[name] ?? "")
		})
	)
];

export default inspectionColumns;
